const faqs = [
  {
    q: '窝窝影院真的完全免费吗？',
    a: '是的，窝窝影院所有电影、电视剧、综艺、动漫等内容均免费提供在线观看，无需任何会员注册费用。我们通过技术优化降低运营成本，致力于为用户提供高清播放、在线不缓冲的免费观影服务。',
  },
  {
    q: '观看画质最高支持多少？',
    a: '窝窝影院支持最高超清画质播放，大部分影片提供 1080P 全高清片源，部分热门内容可达 4K 分辨率。我们采用先进解码技术，确保流畅观看超清画质无广告，让您享受极致观影体验。',
  },
  {
    q: '新片上线速度快吗？',
    a: '窝窝影院内容团队每日更新片源，热门院线电影下映后通常 1-3 个月内即可上线，热播电视剧同步跟播。每日更新不卡顿，海量高清电影电视剧免费在线观看，紧跟全网最新内容动态。',
  },
  {
    q: '支持哪些设备观看？',
    a: '窝窝影院全面支持电脑端、手机浏览器、平板设备在线观看，提供网页版和移动端适配页面。无论您使用什么设备，都能享受高清播放在线不缓冲的一致观影体验。',
  },
  {
    q: '观看需要安装播放器吗？',
    a: '不需要。窝窝影院采用 HTML5 播放技术，打开网页即可播放，无需下载或安装任何第三方播放器。兼容主流浏览器，即点即播，高清流畅无卡顿，真正做到流畅观看超清画质无广告。',
  },
  {
    q: '内容资源丰富吗？覆盖哪些类型？',
    a: '窝窝影院拥有海量片库，覆盖动作片、喜剧片、爱情片、科幻片、恐怖片、动画电影、纪录片、国产剧、港台剧、欧美剧、日韩剧、综艺节目等全品类内容。每日持续更新，满足不同用户的观影需求。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[960px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-primary-100 text-primary-700 mb-3 whitespace-nowrap">
            常见问题
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">
            您关心的，我们都懂
          </h2>
        </div>
        <div className="grid gap-4">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl p-5 md:p-6 hover:bg-background-50 transition-colors"
            >
              <h3 className="font-semibold text-foreground-900 text-base mb-2 flex items-start gap-3">
                <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 text-xs font-bold mt-0.5">
                  Q
                </span>
                {faq.q}
              </h3>
              <p className="text-foreground-600 text-sm leading-relaxed pl-9">
                {faq.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}